var map = {
	"./symbol_0.png": 74133,
	"./symbol_1.png": 91244,
	"./symbol_10.png": 8342,
	"./symbol_11.png": 10700,
	"./symbol_12.png": 50020,
	"./symbol_13.png": 89965,
	"./symbol_14.png": 17458,
	"./symbol_15.png": 15323,
	"./symbol_16.png": 53344,
	"./symbol_17.png": 8169,
	"./symbol_18.png": 79262,
	"./symbol_19.png": 97575,
	"./symbol_2.png": 59719,
	"./symbol_3.png": 88382,
	"./symbol_4.png": 24497,
	"./symbol_5.png": 84552,
	"./symbol_6.png": 21411,
	"./symbol_7.png": 99834,
	"./symbol_8.png": 3693,
	"./symbol_9.png": 77540
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93224;